const state = {
    selectedSell: null, //stores the selected sell(used in form modal)
    sellShow: false, //show=true | edit=false
    showNewSellLineModal: false,
    selectedArticleInSellLine: null,
    showSellModal: false,//controls if the form modal is displayed or not

    invoices: [],
    articles: [],
    paymentCondition: '',
};

const getters = {
    getSelectedSell(state){
        return state.selectedSell;
    },
    getSellShow(state){
        return state.sellShow;
    },
    getShowSellModal(state){
        return state.showSellModal;
    },
    getShowNewSellLineModal(state){
        return state.showNewSellLineModal;
    },

    getSellinvoices(state){
        return state.invoices;
    },
    getArticles(state){
       return state.articles;
    },
    getSelectedArticleInSellLine(state){
        if(!state.selectedArticleInSellLine){
            return {
                articles_id: '',
                detail: '',
                sold_quantity: '',
                quantity_to_be_delivery: '',
                sell_price: '',
                discount: '',
                subtotal: '',
                agreed_discount: 0
            }
        }
        return state.selectedArticleInSellLine;
    },
    getSellPaymentCondition(state){
        return state.paymentCondition;
    },

    getNewSell(state, getters, rootGetters) {
        return {
            code: '',
            clients_id: '',
            companies_id: '',
            company: rootGetters['Company/getNewCompany'],
            model_107_id: '',
            sell_date: '',
            delivery_date: '',
            deadline: '',
            transport: '',
            transport_cost: '',
            types_situation_id: '',
            types_sell_channel_id: '',
            types_document_type_id: '',
            types_operation_type_id: '',
            types_typology_id: '',
            series: '',
            fiscal_area_code: '',
            types_book_id: '',
            types_currency_id: '',
            users_made_id: '',
            users_registered_id: '',
            sell_tax: '',
            articles: [],
        };
    },

    getEmptyFormSell(){
        return {
            searchClientField: '',
            searchEmployeeField: '',
        }
    }
};

const mutations = {
    setSelectedSell(state, payload){ //this also works for new article
        state.selectedSell = payload;
    },
    setPreparedFormSell(state, payload){
        state.formArticle = {
            searchClientField: payload  && payload.client ? payload.client.name : '',
            searchEmployeeField: payload && payload.made_by_user ? payload.made_by_user.name : '',
        };
    },
    setSellShow(state, payload){ //this also works for new article
        state.sellShow = payload;
    },
    setShowSellModal(state, payload){
        state.showSellModal = payload;
    },
    setShowNewSellLineModal(state, payload){
        state.showNewSellLineModal = payload;
    },

    setSellInvoices(state, payload){
        return state.invoices = payload;
    },
    setSellPaymentCondition(state, payload){
        return state.paymentCondition = payload;
    },
    setArticles(state, payload){
        return state.articles = payload;
    },
    setSelectedArticleInSellLine(state, payload){
        return state.selectedArticleInSellLine = payload;
    }
};

const actions = {
    setSelectedSell( {commit}, payload){
        commit('setSelectedSell', payload);
        commit('setPreparedFormSell', payload);
    },
    setSellShow({commit}, payload){
        commit('setSellShow', payload);
    },
    setShowSellModal({commit}, payload){
        commit('setShowSellModal', payload);
    },
    setShowNewSellLineModal({commit}, payload){
        commit('setShowNewSellLineModal', payload);
    },

    setSellInvoices({commit}, payload){
        commit('setSellInvoices', payload);
    },
    setSellPaymentCondition({commit}, payload){
        commit('setSellPaymentCondition', payload);
    },
    setArticles({commit}, payload){
        commit('setArticles', payload);
    },
    setSelectedArticleInSellLine({commit}, payload){
        commit('setSelectedArticleInSellLine', payload);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};

